export default {"src":"/_next/static/media/background3.7c8cac0c.svg","height":173,"width":221};